import React, { useState } from 'react';

import { handleStartNewProject } from '../../../../helpers/startNewJobFormUtils';

import { useResponsiveBreakpoints } from '../../../../hooks/useResponsiveBreakpoints';

import Button from '../../../../design-system/Button/Button';
import ErrorAlert from '../../../../design-system/ErrorAlert/ErrorAlert';
import NewJobForm from '../../../../components/NewJobForm/NewJobForm';
import PlayCircleFillIcon from '../../../../design-system/Icons/PlayCircleFillIcon';

const StartNewProjectFormBlock = ({
    scenarioData,
    formData,
    setFormData,
    startNewProjectState,
    setStartNewProjectState,
    setNewProjectId,
}) => {
    const [errorAlert, setErrorAlert] = useState(null);

    const { isMobile } = useResponsiveBreakpoints({ maxMobileWidth: 768 });

    const onStartAutoRun = async () => {
        const scenarioVersionId = scenarioData.default_version.id;
        await handleStartNewProject({
            formData,
            setFormData,
            setNewProjectId,
            setStartNewProjectState,
            scenarioVersionId,
            setErrorAlert,
        });
    };

    return (
        <div className="p-5 sm:p-8">
            <div className="mb-5">
                <h1 className="font-heading-bold text-heading-bold-l text-black mb-1">
                    {scenarioData.name}
                </h1>
                {/* <p className="font-body text-body-regular-s text-neutral-400">
                    {scenarioData.description}
                </p> */}
            </div>

            <div className="py-6 sm:py-8 px-5 sm:px-8 lg:px-[40px] w-full max-w-[800px] mx-auto rounded-2xl bg-white flex flex-col gap-6 md:gap-7">
                <div>
                    <p className="font-heading-bold text-heading-bold-m text-black mb-2">
                        Start New Project{' '}
                    </p>
                    <p className="font-body text-body-regular-s text-neutral-400">
                        Fill out the required inputs to start this project and automatically kick
                        off its connected agents.
                    </p>
                </div>

                <NewJobForm
                    formData={formData}
                    setFormData={setFormData}
                    containerGap={isMobile ? 24 : 28}
                />

                <div className="py-4">
                    <div className="pt-4 border-t-1 border-neutral-200 flex justify-end">
                        <Button
                            type="secondary"
                            size="sm"
                            text="Start Auto-Run"
                            state={startNewProjectState === 'loading' ? 'loading' : 'default'}
                            trailingIcon={PlayCircleFillIcon}
                            onClick={onStartAutoRun}
                        />
                    </div>
                </div>
            </div>

            <ErrorAlert errorAlert={errorAlert} setErrorAlert={setErrorAlert} />
        </div>
    );
};

export default StartNewProjectFormBlock;
